import Exercises from './Exercises';

export default Exercises;
